import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {CardComponent} from "../../../shared-module/components/card/card.component";
import {ButtonComponent} from "../../../shared-module/components/button/button.component";
import {DividerComponent} from "../../../shared-module/components/divider/divider.component";
import {BadgeComponent} from "../../../shared-module/components/badge/badge.component";
import {ApplicationConfig, config} from "../../../../config";
import ModalService from "../../../shared-module/services/modal.service";
import {
  EditPasswordDialogComponent
} from "../../components/my-account-dialogs/edit-password-dialog/edit-password-dialog.component";
import {
  EditEmailDialogComponent
} from "../../components/my-account-dialogs/edit-email-dialog/edit-email-dialog.component";
import {AuthService} from "../../../shared-module/services/auth.service";
import RelationContact from "../../../shared-module/model/relation-contact.model";
import PhonePipe from "../../../shared-module/pipes/phone.pipe";
import AddressPipe from "../../../shared-module/pipes/address.pipe";

import Relation from "../../../shared-module/model/relation.model";
import PostalAddressPipe from "../../../shared-module/pipes/postal-address.pipe";
import {InvoiceTypeTranslations, RelationInvoiceType} from "../../../shared-module/enums/relation-invoice-type";
import {InvoicePeriodTranslations, RelationInvoicePeriod} from "../../../shared-module/enums/relation-invoice-period";
import {IconComponent} from "../../../shared-module/components/icon/icon.component";
import {ToggleComponent} from "../../../shared-module/components/toggle/toggle.component";
import CommunicationPreferenceStore from "../../../shared-module/services/Stores/communication-preference.store";
import CommunicationPreferences from "../../../shared-module/model/communication-preferences.model";

@Component({
    selector: 'app-my-account',
    imports: [
    CardComponent,
    ButtonComponent,
    DividerComponent,
    BadgeComponent,
    PhonePipe,
    AddressPipe,
    PostalAddressPipe,
    IconComponent,
    ToggleComponent
],
    templateUrl: './my-account.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './my-account.component.scss'
})
export class MyAccountComponent implements OnInit {
  private readonly modalService: ModalService = inject(ModalService);
  protected readonly authService: AuthService = inject(AuthService);
  private readonly communicationPreferenceStore: CommunicationPreferenceStore = inject(CommunicationPreferenceStore);

  protected readonly config: ApplicationConfig = config;

  public user: RelationContact | null = null;
  protected activeRelation: Relation | null = null;
  protected relationContacts: RelationContact[] = [];

  protected readonly InvoiceTypeTranslations: Record<RelationInvoiceType, string> = InvoiceTypeTranslations;
  protected readonly InvoicePeriodTranslations: Record<RelationInvoicePeriod, string> = InvoicePeriodTranslations;
  protected readonly RelationInvoiceType: typeof RelationInvoiceType = RelationInvoiceType;
  protected readonly RelationInvoicePeriod: typeof RelationInvoicePeriod = RelationInvoicePeriod;

  public ngOnInit(): void {
    this.authService.getUser(['relations.relation_contacts']).subscribe((user: RelationContact | null) => {
      this.user = user;
    })

    this.authService.getActiveRelation().subscribe(
      (relation: Relation | null) => {
        this.activeRelation = relation;
        if (!relation?.relation_contacts) {
          this.relationContacts = [];
          return;
        }
        //logged-in user displayed first, the rest sorted on last name
        this.relationContacts = [...relation.relation_contacts].sort((a, b) => {
          if (a.email === this.user?.email) return -1;
          if (b.email === this.user?.email) return 1;
          return a.lastname.localeCompare(b.lastname);
        });
      }
    );
  }

  public editEmail(): void {
    this.modalService.open(EditEmailDialogComponent, null, {
      title: 'E-mailadres wijzigen',
      subtitle: 'Wijzig hier jouw e-mailadres.',
      width: '700px',
      showCloseButton: true,
      badgeIcon: 'envelope'
    });
  }

  public editPassword(): void {
    this.modalService.open(EditPasswordDialogComponent, null, {
      title: 'Wachtwoord wijzigen',
      subtitle: 'Op deze pagina kun je jouw wachtwoord wijzigen voor de ' + this.config.appName + ' omgeving. Vul je huidig wachtwoord in en kies een nieuw wachtwoord om je account te beveiligen.',
      width: '700px',
      showCloseButton: true,
      badgeIcon: 'lock'
    });
  }

  protected onToggleChange(event: { name: string; checked: boolean }) {
    if (this.activeRelation != null) {
      this.communicationPreferenceStore.reset().forParent('relation', this.activeRelation)
      const newCommunicationPreference: CommunicationPreferences = new CommunicationPreferences();
      switch (event.name) {
        case 'email':
          this.activeRelation.communication_preferences.email = event.checked
          newCommunicationPreference.email = event.checked
          break;
        case 'phone':
          this.activeRelation.communication_preferences.phone = event.checked
          newCommunicationPreference.phone = event.checked
          break;
      }
      this.communicationPreferenceStore.create(newCommunicationPreference).subscribe({
        next: (() => {
          this.authService.getUser(['relations']).subscribe();
        }),
        error: (() => {
          this.authService.getUser(['relations']).subscribe();
        })
      });
    }
  }
}
